import { dateIsValid } from './dateIsValid'

export function parseDateString(input: unknown): Date | undefined {
  if (typeof input !== 'string' && !(input instanceof Date)) {
    return undefined
  }

  const date = input instanceof Date ? input : new Date(input)

  if (!dateIsValid(date)) {
    return undefined
  }

  return date
}
